import { CommentApi, PostApi } from "../pages/DashBoard/partials/Feed/types/types";
import { buildFeedPostUpdateFormData } from "./buildFeedPostUpdateFormData";
import { getParsedArray } from "./getParsedArray";

interface NewPostDataProps {
  post: PostApi;
  comment: CommentApi;
  content: string;
}

export const createUpdatedCommentsFormData = ({post, comment, content}: NewPostDataProps) => {
  const parsedComments: CommentApi[] = getParsedArray(post.comments);
  const updatedComments = parsedComments.map((prevComment) => {
    if (prevComment.created_at === comment.created_at) {
      return {
        ...comment,
        content: content,
        edited_at: new Date().toISOString(),
      };
    }
    return prevComment;
  });

  return buildFeedPostUpdateFormData(post, {
    comments: JSON.stringify(updatedComments),
  });
};
